import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import type { UseModalReturn } from '@percent/domain/giving'

export type CancelCampaignSuccessModalProps = Pick<UseModalReturn, 'isOpen' | 'closeModal'>

export function CancelCampaignSuccessModal({ isOpen, closeModal }: CancelCampaignSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={closeModal} aria-labelledby="cancel-campaign-success">
      <AcknowledgeModal
        result="positive"
        title={t('workplace_giving.myCampaigns.actions.cancelSuccessModal.title')}
        buttonText={t('workplace_giving.common.close')}
        handleClose={closeModal}
        buttonTestId="success-modal-btn"
      >
        {t('workplace_giving.myCampaigns.actions.cancelSuccessModal.description')}
      </AcknowledgeModal>
    </Modal>
  )
}
